export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./my-organisation-competencies.vue?vue&type=template&id=41be3080&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/my-organisation-competencies.vue?vue&type=template&id=41be3080&
// module id = 1710
// module chunks = 0